// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.table-container {
    /* max-height: 100px; */
    margin: auto;
    max-width: 90%;
    overflow: auto;
    border: 1px solid #ddd;
    font-size: 0.9em;
}

.table-container thead th {
    position: sticky;
    top: 0;
    z-index: 1;
    background-color: #f2f2f2;
}

.noinv-recs {
    width: 100%;
    border-top: 1px solid gray;
    border-radius: 10px;
    padding: 0px 0px 10px 0px;
    margin-top: 20px;;

}

.noinv-recs-with-data {
    border-bottom: 1px solid #bbb;
    border-left: 1px solid gray; 
    border-right: 1px solid gray; 
}

.noinv-recs-td {
    font-size: 0.9rem;
}`, "",{"version":3,"sources":["webpack://./src/components/NoInventories.css"],"names":[],"mappings":"AAAA;IACI,uBAAuB;IACvB,YAAY;IACZ,cAAc;IACd,cAAc;IACd,sBAAsB;IACtB,gBAAgB;AACpB;;AAEA;IAEI,gBAAgB;IAChB,MAAM;IACN,UAAU;IACV,yBAAyB;AAC7B;;AAEA;IACI,WAAW;IACX,0BAA0B;IAC1B,mBAAmB;IACnB,yBAAyB;IACzB,gBAAgB;;AAEpB;;AAEA;IACI,6BAA6B;IAC7B,2BAA2B;IAC3B,4BAA4B;AAChC;;AAEA;IACI,iBAAiB;AACrB","sourcesContent":[".table-container {\n    /* max-height: 100px; */\n    margin: auto;\n    max-width: 90%;\n    overflow: auto;\n    border: 1px solid #ddd;\n    font-size: 0.9em;\n}\n\n.table-container thead th {\n    position: -webkit-sticky;\n    position: sticky;\n    top: 0;\n    z-index: 1;\n    background-color: #f2f2f2;\n}\n\n.noinv-recs {\n    width: 100%;\n    border-top: 1px solid gray;\n    border-radius: 10px;\n    padding: 0px 0px 10px 0px;\n    margin-top: 20px;;\n\n}\n\n.noinv-recs-with-data {\n    border-bottom: 1px solid #bbb;\n    border-left: 1px solid gray; \n    border-right: 1px solid gray; \n}\n\n.noinv-recs-td {\n    font-size: 0.9rem;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
